import React from "react";
import PropTypes from "prop-types";
// Material imports
import { ThemeProvider } from "@mui/material/styles";
//Limitless imports
import { CompactKnowledgeBase, ExtraCustomerInfo, Classification } from "../../../..";
import ConversationTabs from "../../conversation-tabs/ConversationTabs";
import ConversationRespondPanelFooter from "../conversation-respond-panel/ConversationRespondPanelFooter";
import ConversationDetailedReviewFeedback from "./ConversationDetailedReviewFeedback";
import ConversationTabContent from "../conversation-tab-content/ConversationTabContent";
import ConversationDetailedReviewPanelFooter from "../conversation-detailed-review-footer/ConversationDetailedReviewPanelFooter";
import { useTranslation } from "@limitless/common/hooks";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import { useExpertProfileContext } from "../../../../../expert";
import { useExpertMessageQualityReviewContext } from "../../../../../expert/hooks/expert-message-quality-review/ExpertMessageQualityReviewContext";
import { isQualityReviewState } from "../../../..";
import { useExpertMessageContext } from "../../../../../expert";
import ConversationTab from "../../../conversation-tab/ConversationTab";
import { calculateReviewSummary } from "@limitless/portal";
const ConversationDetailedReviewPanel = ({
  message,
  messageResources
}) => {
  var _message$onboarding;
  const [activeTab, setActiveTab] = React.useState(0);
  const {
    isDarkMode
  } = useExpertProfileContext();
  const {
    cancelEditingMessage
  } = useExpertMessageContext();
  const {
    reviewState,
    feedbackIsAIDraftSelected,
    setFeedbackIsAIDraftSelected,
    setUpdatedReviewCriteriaByAI,
    updateQualityReviewCriteria,
    updateQualityReviewNote,
    updateReviewSchemeText,
    setReviewState,
    saveQualityReview,
    updateIsAIDraftSelected,
    updateFeedback,
    updateReviewCriteriaByAI,
    updatedReviewCriteriaByAI
  } = useExpertMessageQualityReviewContext();
  const {
    reviewCriteria,
    reviewNote,
    reviewNoteError
  } = reviewState;
  const {
    isAIDraftSelected,
    feedback
  } = feedbackIsAIDraftSelected;
  const {
    aiReviweCriteria
  } = updatedReviewCriteriaByAI;
  const {
    t
  } = useTranslation();
  const reviewSummary = calculateReviewSummary(message, true);
  const {
    hasCorrectReply
  } = reviewSummary;
  const showReviewCriteria = message.practiceGroup ? hasCorrectReply && ((_message$onboarding = message.onboarding) === null || _message$onboarding === void 0 ? void 0 : _message$onboarding.responseType) === "dia" : true;
  const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);
  React.useEffect(() => {
    if (message.messageId && isQualityReviewState(message.conversationState.state)) {
      setReviewState({
        isReviewComplete: false,
        reviewNote: "",
        reviewCriteria: message.reviewCriteria ? [...message.reviewCriteria] : []
      });
      setFeedbackIsAIDraftSelected({
        isAIDraftSelected: false,
        feedback: ""
      });
      setUpdatedReviewCriteriaByAI({
        aiReviweCriteria: []
      });
    }
  }, [message.messageId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConversationTabs, {
    activeTab: activeTab,
    onTabChange: setActiveTab,
    message: message,
    showKnowledge: false
  }, /*#__PURE__*/React.createElement(ConversationTab, {
    id: "expertQualityReviewTab",
    label: "Review"
  }), /*#__PURE__*/React.createElement(ConversationTab, {
    id: "knowledgeTab",
    label: "Knowledge",
    hide: !(message !== null && message !== void 0 && message.knowledgeBaseIsActive)
  })), /*#__PURE__*/React.createElement(ConversationTabContent, null, activeTab === 0 && /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ConversationDetailedReviewFeedback, {
    reviewNotesEnabled: message.reviewNotesEnabled,
    reviewCriteria: showReviewCriteria ? reviewCriteria : [],
    showReviewCriteria: showReviewCriteria,
    aiReviweCriteria: aiReviweCriteria ? aiReviweCriteria : [],
    updateReviewCriteriaByAI: updateReviewCriteriaByAI,
    reviewNote: reviewNote,
    onCriteriaChange: updateQualityReviewCriteria,
    onNoteChange: updateQualityReviewNote,
    onReviewCriteriaText: updateReviewSchemeText,
    reviewNoteError: reviewNoteError || "",
    messageId: message.messageId,
    messageAiReview: message.aiReview,
    onAIDraftChange: updateIsAIDraftSelected,
    onFeedbackChange: updateFeedback,
    feedback: feedback,
    isAIDraftSelected: isAIDraftSelected,
    isAIAssistEnabled: message.isAIAssistEnabled,
    message: message
  })), activeTab === 1 && /*#__PURE__*/React.createElement(CompactKnowledgeBase, {
    isKnowledgeActive: message.knowledgeBaseIsActive
  }), activeTab === 2 && /*#__PURE__*/React.createElement(Classification, {
    message: message,
    messageResources: messageResources,
    isReadOnly: true
  }), activeTab === 3 && /*#__PURE__*/React.createElement(ExtraCustomerInfo, null)), activeTab !== 0 ? /*#__PURE__*/React.createElement(ConversationRespondPanelFooter, null) : /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ConversationDetailedReviewPanelFooter, {
    cancelEditingMessage: cancelEditingMessage,
    saveQualityReview: saveQualityReview,
    completeReviewDisabled: showReviewCriteria ? !reviewState.isReviewComplete : false
  })));
};
export default ConversationDetailedReviewPanel;
ConversationDetailedReviewPanel.propTypes = {
  message: PropTypes.object.isRequired,
  messageResources: PropTypes.object.isRequired
};